import { type Action, createStore } from 'react-sweet-state';

type FileOpenHandler = () => void;

export type State = {
	handlers: FileOpenHandler[];
};

export type Actions = typeof actions;

const actions = {
	register:
		(handler: FileOpenHandler): Action<State> =>
		({ setState, getState }) => {
			if (getState().handlers.includes(handler)) return;
			setState({ handlers: [...getState().handlers, handler] });
		},
	unregister:
		(handler: FileOpenHandler): Action<State> =>
		({ setState, getState }) => {
			setState({ handlers: getState().handlers.filter((h) => h !== handler) });
		},
	openFileDialog:
		(): Action<State> =>
		({ getState }) => {
			// Call the most recently registered handler (last mount wins)
			const { handlers } = getState();
			const lastHandler = handlers[handlers.length - 1];
			lastHandler?.();
		},
};

export const Store: ReturnType<typeof createStore<State, Actions>> = createStore<State, Actions>({
	name: 'file-upload-trigger',
	initialState: { handlers: [] },
	actions,
});
